import CustomImage from '../../fragments/custom-image/CustomImage';
import Cta from '../../fragments/cta/Cta';
import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';

export default function HeroCta({ block, index, globalData }) {
  if (!block) return null;

  const HeadingTag = index === 0 ? 'h1' : 'h2';

  const cta = block.cta || globalData?.heroCtaFallback || false;

  // console.log(block);

  return (
    <ComponentWrapper
      block={block}
      className="HeroCta"
      padding={false}
      colorDynamic
    >
      <div className={'l-grid'}>
        <div
          className={`l-grid__col l-grid__col--l-10-12 l-grid__col--l-push-1-12`}
        >
          <div className="HeroCta-inner colorDynamicBg">
            <div className={`HeroCta-content`}>
              {block.heading && (
                <HeadingTag className={`HeroCta-heading h2`}>
                  {block.heading}
                </HeadingTag>
              )}
              {block.description && (
                <p className="HeroCta-description">{block.description}</p>
              )}
              <div className="HeroCta-cta ">
                {cta && <Cta cta={cta} />}
                {block.ctaSecondary && (
                  <Cta cta={block.ctaSecondary} theme="secondary" />
                )}
              </div>
            </div>
            {block.image && (
              <div className="HeroCta-media">
                <CustomImage
                  image={block.image}
                  fill={true}
                  desktopWidth={50}
                />
              </div>
            )}
          </div>
        </div>
        <div className="HeroCta-mediaBackground">
          {block.imageBackground && (
            <CustomImage
              image={block.imageBackground}
              fill={true}
              parallax={true}
              desktopWidth={100}
            />
          )}
        </div>
      </div>
    </ComponentWrapper>
  );
}
